module.exports = __webpack_public_path__ + "img/4.e609cb98.svg";